/* eslint-disable max-lines */
import { AfterContentChecked, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { CssClass, KngHeaderNav, KngHeaderNavMenuOption, KngHeaderNavOptionSelectOn, KngHeaderNavStateItem, Location, KnHeaderCustomerState } from './definitions/kng-header-nav.interface';
import { KngHeaderNavFactory } from './kng-header-nav.factory';
import { HeaderNav, HeaderUrl } from '../../../shared/shared.interface';
@Component({
	selector: 'kng-header-nav',
	templateUrl: './template/kng-header-nav.component.html',
	styleUrls: ['./template/kng-header-nav.component.scss']
})
export class KngHeaderNavComponent implements KngHeaderNav, OnDestroy, OnInit, AfterContentChecked 
{
	headerTop!: KngHeaderNavStateItem;
	mobileHeaderMenu!: KngHeaderNavStateItem;
	headerBottom!: KngHeaderNavStateItem;
	showSettingsMenu: boolean = false;
	subMenuSelected: boolean = false;
	subLocationMenuSelected: boolean = false;
	showLocationDropdown: boolean = false;
	settingsMenu!: KngHeaderNavMenuOption;
	subOptionArray!: Array<KngHeaderNavMenuOption>;
	headerlogos!: Array<KngHeaderNavMenuOption>;
	username: string = ' ';
	showellipsis: boolean = false;
	cssClass = CssClass;
	unSelectNav: boolean = false;
	unSelectHeader: boolean = false;
	unSelectMobileHeader: boolean = false;
	currentRoute: string = '';
	userSelected = false;
	navTabIndex: number = 0;
	skipNavText: string = 'Skip Navigation';
	private state$: BehaviorSubject<KngHeaderNavStateItem[]> = new BehaviorSubject<KngHeaderNavStateItem[]>(KngHeaderNavFactory.buildState());
	private unlistener: () => void;
	locationListArray: Location[] | undefined = [];
	selectedLocation!: Location | undefined;
	accountNameEllipsis: boolean = false;
	switchRole: string = HeaderNav.switchRole;
	get state(): KngHeaderNavStateItem[] { return this.state$.value; }
	@Input() set state(value: KngHeaderNavStateItem[]) 
	{
		this.state$.next(value);
		this.getHeaderData();
	}
	@Input() customerState: KnHeaderCustomerState = KngHeaderNavFactory.buildheaderCustomerState();
	@ViewChild('sidenav') sidenav!: MatSidenav;
	@Output() clickEventTop: EventEmitter<KngHeaderNavOptionSelectOn> = new EventEmitter<KngHeaderNavOptionSelectOn>();
	@Output() customerSessionEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() clickEventLocationTop: EventEmitter<Location> = new EventEmitter<Location>();
	@Output() clickEventBottom: EventEmitter<KngHeaderNavOptionSelectOn> = new EventEmitter<KngHeaderNavOptionSelectOn>();
	@Output() clickHeaderLogo: EventEmitter<KngHeaderNavOptionSelectOn> = new EventEmitter<KngHeaderNavOptionSelectOn>();
	constructor(private renderer: Renderer2, public router: Router, private scroller: ViewportScroller)
	{
		this.unlistener = this.renderer.listen('window', 'mousedown', () => 
		{
			if (!this.subMenuSelected) this.showSettingsMenu = false;
			if (!this.subLocationMenuSelected) this.showLocationDropdown = false;
		});
		this.renderer.listen('window', 'keydown', (e) => 
		{
			if (e.key === 'Escape') 
			{
				if (!this.subMenuSelected) this.showSettingsMenu = false;
				if (!this.subLocationMenuSelected) this.showLocationDropdown = false;
			}
		});
	}
	@HostListener('document:keydown', ['$event'])
	onKeyPress(event: KeyboardEvent): void 
	{
		const clickedElement = event.target as HTMLElement;
		if (event.key === 'Enter' && clickedElement.classList.contains(CssClass.locationListDropdown)) 
		{
			this.clickDropdownArrow();
		}
	}
	ngOnInit() 
	{

		this.router.events.subscribe(event => 
		{
			if ((event instanceof NavigationEnd)) 
			{
				this.currentRoute = event.url;
			}
			this.checkCurrentRoute();
		});
	}
	ngAfterContentChecked(): void 
	{
		this.state$.subscribe(value => 
		{
			if(value)
			{
				this.locationListArray = this.state?.filter((elem) => elem.cssClass === CssClass.global)[0].menu?.filter((item) => item.cssClass === CssClass.locationListDropdown)[0]?.locations;
				this.selectedLocation = this.locationListArray? this.locationListArray.filter(item => item.adminId === true)[0] : undefined;
				this.getUserName();
				this.shouldShowAccountNameEllipsis();
			}
		});

	}
	shouldShowAccountNameEllipsis()
  	{
		if(this.selectedLocation && this.selectedLocation?.accountName?.length>10)
			this.accountNameEllipsis = true;
		else
			this.accountNameEllipsis = false;
  	}
	getInitials(userName: string) : string
  	{
		const words = userName.split(' ');
		const initials = words.map(word => word.charAt(0).toUpperCase()).join('');
		return initials;
  	}
  	getUserName()
  	{
		if (this.locationListArray && this.locationListArray.length > 0) 
		{
			this.username = this.getInitials(this.headerTop?.menu?.filter((item) => item.cssClass === CssClass.user)[0]?.label);
		}
		else { this.username = this.headerTop?.menu?.filter((item) => item.cssClass === CssClass.user)[0]?.label; }
	}
	selectedAccordion: HTMLElement | null = null;
	toggleHelper(event: Event, accordion: HTMLElement, panel: HTMLElement): void 
	{
		event.preventDefault();
		this.selectedAccordion = accordion;
		this.selectedAccordion.classList.toggle('active');
		panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
	}
	checkCurrentRoute()
	{
		if (this.currentRoute.includes(HeaderUrl.userManagement) || this.router.url.includes(HeaderUrl.rolesPermissions) || this.currentRoute.includes(HeaderUrl.accountSetting) || this.currentRoute.includes(HeaderUrl.locationManagment)) 
		{
			this.userSelected = true;
			this.unSelectNav = true;
			this.subOptionArray?.forEach((item) => 
			{
				item.isSelected = false;
				item.isSelected = this.currentRoute.includes(item.url) && (item.url !== '');
			});
			this.updateSelectionState(false);
		}
		else if(this.isMainNavSelected())
		{
			this.unSelectNav = false;
			this.headerBottom?.menu?.forEach((item) => 
			{
				item.isSelected = false;
				item.isSelected = this.currentRoute.includes(item.url);
			});
			this.userSelected = false;
			this.updateSubSelectionState(false);
		}
		else 
		{
			this.userSelected = false;
		}
	}
	isMainNavSelected()
	{
		return this.currentRoute.includes(HeaderUrl.dashboard) || this.currentRoute.includes(HeaderUrl.orderMangement) || this.currentRoute.includes(HeaderUrl.myfleet) || this.currentRoute.includes(HeaderUrl.serviceManagement) || this.currentRoute.includes(HeaderUrl.myQuotes) || this.currentRoute.includes(HeaderUrl.myInsights);
	}
	updateSelectionState(state: boolean)
	{
		this.headerBottom.menu?.forEach((item) => { item.isSelected = state; });
	}
	updateSubSelectionState(state: boolean)
	{
		this.subOptionArray?.forEach((item) => { item.isSelected = state; });
	}
	getHeaderData() 
	{
		this.headerTop = this.state?.filter((elem) => elem.cssClass === CssClass.global)[0];
		this.headerBottom = this.state?.filter((elem) => elem.cssClass === CssClass.portal)[0];
		this.mobileHeaderMenu = this.state?.filter((elem) => elem.cssClass === CssClass.mobile)[0];
		this.getSubOptionAndHeaderArray();
		this.locationListArray = this.headerTop?.menu?.filter((item) => item.cssClass === CssClass.locationListDropdown)[0]?.locations;
		this.selectedLocation = this.locationListArray? this.locationListArray.filter(item => item.adminId === true)[0] : undefined;
		this.getUserName();
		this.shouldShowAccountNameEllipsis();
		if (this.username?.length > 21) 
			this.showellipsis = true;
		this.setIsSelectedHeaderBottom();
	}
	setIsSelectedHeaderBottom() 
	{
		const routUrl = this.router.url.split('/');
		if (routUrl) 
		{
			this.headerBottom?.menu?.forEach((item) => 
			{
				item.isSelected = false;
				if (item.label === HeaderNav.orderMangement || item.label === HeaderNav.myfleet || item.label === HeaderNav.serviceManagement || this.isMyQuotesOrMyInsights(item.label)) 
				{
					this.userSelected = false;
					item.isSelected = this.router.url.includes(item.url);
				}
				else if (item.label !== HeaderNav.dashboard)
					this.setIsSelectedSubOptionCategories(routUrl, item);
				else 
					this.setIsSelectedForDashboard(routUrl, item);
			});
			this.unSelectMobileHeader = (!this.router.url.includes('notify'));
			this.setIsSelectedHeader();
			this.setIsSelectedSubOption();
		}
	}
	isMyQuotesOrMyInsights(title: string)
	{
		return (title === HeaderNav.myQuotes || title === HeaderNav.myInsights);
	}
	setIsSelectedForDashboard(routUrl: string[], item: KngHeaderNavMenuOption)
	{
		this.userSelected = false;
		const url = routUrl.pop();
		if (url)
			item.isSelected = (item.url.includes(url.toLowerCase()) || url === ('app'));
	}
	public selectHeaderMenu(option: KngHeaderNavMenuOption, event: Event): void 
	{
		this.resetNavIndex();
		if (option.cssClass === CssClass.user) 
			this.showSettingsMenu = true;
		this.clickEventTop.emit({ event, selection: option });
		this.router.events.subscribe(event => 
		{
			if ((event instanceof NavigationEnd)) 
			{
				if (!(/toyota/i.exec(option.altText)))
					this.unSelectNav = true;
				this.unSelectHeader = false;
				this.checkCurrentRoute();
			}
		});
	}
	closeMenu() { this.subMenuSelected = false; }
	displayMenu() { this.subMenuSelected = true; }
	closeLocationMenu() { this.subLocationMenuSelected = false; }
	displayLocationMenu() { this.subLocationMenuSelected = true; }
	clickDropdownArrow() { this.showLocationDropdown = !this.showLocationDropdown; }
	public selectNavMenu(option: KngHeaderNavMenuOption, tag: string, event: Event): void 
	{
		this.resetNavIndex();
		if (tag === 'nav') 
		{
			this.clickEventBottom.emit({ event, selection: option });
			this.router.events.subscribe(event => 
			{
				if ((event instanceof NavigationEnd)) 
				{
					this.unSelectNav = false;
					this.unSelectHeader = true;
					this.headerBottom?.menu?.forEach((item) => 
					{
						item.isSelected = false;
						if (item.label === HeaderNav.orderMangement || item.label === HeaderNav.myfleet || item.label === HeaderNav.serviceManagement  || this.isMyQuotesOrMyInsights(item.label)) 
						{
							this.userSelected = false;
							item.isSelected = this.currentRoute.includes(item.url);
						}
						else
							item.isSelected = (item.url === this.currentRoute);
					});
				}
			});
		}
	}
	public selectSubLocationOption(location: Location, tag: string): void 
	{
		if (tag === 'header') 
		{
			this.subLocationMenuSelected = true;
			if(location !== this.selectedLocation) this.clickEventLocationTop.emit(location);
			this.showLocationDropdown = false;
		}
	}
	public selectSubLocationOptionMobile(location: Location): void 
	{
		if(location !== this.selectedLocation) this.clickEventLocationTop.emit(location);
	}
	public selectSubOption(subOption: KngHeaderNavMenuOption, tag: string, event: Event): void 
	{
		if (tag === 'header') 
		{
			subOption.isSelected = true;
			this.subMenuSelected = true;
			this.clickEventTop.emit({ event, selection: subOption });
			this.router.events.subscribe(event => 
			{
				if ((event instanceof NavigationEnd)) 
				{
					this.unSelectNav = true;
					this.unSelectHeader = true;
					this.subOptionArray?.forEach((item) => 
					{
						item.isSelected = false;
						item.isSelected = this.currentRoute.includes(item.url) && (item.url !== '');
						this.userSelected = true;
					});
					this.checkCurrentRoute();
				}
			});
			this.showSettingsMenu = false;
		}
	}
	selectMobileMenu(option: KngHeaderNavMenuOption, event: Event) 
	{
		this.clickEventTop.emit({ event, selection: option });
		this.router.events.subscribe(event => 
		{
			if ((event instanceof NavigationEnd)) 
			{
				this.mobileHeaderMenu?.menu?.forEach((item) => 
				{
					if (item.label === HeaderNav.orderMangement || item.label === HeaderNav.myfleet || item.label === HeaderNav.serviceManagement  || this.isMyQuotesOrMyInsights(item.label))
						item.isSelected = this.currentRoute.includes(item.url);
					else
						item.isSelected = this.currentRoute.includes(item.url) && (item.url !== '');
				});
			}
		});
		this.unSelectMobileHeader = true;
		this.sidenav.close()?.catch(error => 
		{
			// eslint-disable-next-line no-console
			console.log(error, 'error');
		});
	}
	logoClicked(event: Event, option: KngHeaderNavMenuOption) 
	{
		this.clickEventTop.emit({ event, selection: option });
		this.unSelectNav = true;
		this.unSelectMobileHeader = false;
	}
	ngOnDestroy(): void { this.unlistener(); }
	resetNavIndex() { this.navTabIndex = 0; }
	skipNavigation(): void 
	{
		if (this.navTabIndex === 0) 
		{
			this.navTabIndex = -1;
			this.skipNavText = 'Go Through Navigation';
			this.scroller.scrollToAnchor('mainContent');
			const input: HTMLDivElement | null = document.querySelector('#mainContent') as HTMLDivElement;
			if (input !== null)
				input.focus();
		}
		else if (this.navTabIndex === -1) 
		{
			this.resetNavIndex();
			this.skipNavText = 'Skip Navigation';
		}
	}
	setIsSelectedHeader() 
	{
		const routUrl = this.router.url.split('/');
		if (routUrl)
			this.mobileHeaderMenu?.menu?.forEach((item) => 
			{
				item.isSelected = false;
				if (item.label === HeaderNav.dashboard || item.label === HeaderNav.orderMangement || item.label === HeaderNav.myfleet || item.label === HeaderNav.serviceManagement  || this.isMyQuotesOrMyInsights(item.label))
					item.isSelected = this.router.url.includes(item.url);
				else
					this.setIsSelectedSubOptionCategories(routUrl, item);
			});
	}
	setIsSelectedSubOption() 
	{
		const routUrl = this.router.url.split('/');
		if (routUrl) 
		{
			this.subOptionArray?.forEach((item) => { this.setIsSelectedSubOptionCategories(routUrl, item); });
		}
	}
	getSubOptionAndHeaderArray() 
	{
		this.subOptionArray = this.headerTop?.menu?.filter((item) => item.cssClass === CssClass.user)[0]?.submenu;
		this.headerlogos = this.headerTop?.menu?.filter((item) => item.cssClass === CssClass.logos || item.cssClass === CssClass.notification);
	}
	showEllipsis(userName: string) 
	{
		return userName.length > 21;
	}
	setIsSelectedSubOptionCategories(routUrl: string[], item: KngHeaderNavMenuOption) 
	{
		item.isSelected = false;
		let flag: number = 0;
		routUrl.forEach((url) => 
		{
			if (item.url.includes(url.toLowerCase()) && url !== ('app') && url !== ('') && url !== ('dashboard'))
				flag++;
		});
		if (flag > 0) 
		{
			item.isSelected = true;
			this.userSelected = true;
		}
		else { item.isSelected = false; }
	}
	endCustomerSession()
	{
		this.customerSessionEvent.emit('end');
	}
}
